import React, { useState } from 'react';
import axios from 'axios';

/**
 * Chapter 12 — LET'S TALK
 * Final chapter with email copy functionality, direct contact links, and contact form.
 */
const ContactChapter = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText('shawaizali788@gmail.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg('');
    setSubmitted(false);

    axios.post('/api/contact', formData)
      .then((res) => {
        if (res.data && res.data.success) {
          setSubmitted(true);
          setFormData({ name: '', email: '', message: '' });
          setTimeout(() => setSubmitted(false), 6000);
        } else {
          setErrorMsg(res.data.error || 'Server Error: Could not send message.');
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Contact submit error:', err);
        const backendErr = err.response?.data?.error || 'Server Error: Could not connect to backend mail server. Please try again later.';
        setErrorMsg(backendErr);
        setLoading(false);
      });
  };

  return (
    <section className="contact-chapter section-padding">
      <div className="container-editorial">
        <div className="chapter-tag font-mono">CHAPTER 12 // LET'S TALK</div>
        <h2 className="chapter-headline font-display">
          Start A <span className="editorial-accent-text">Conversation.</span>
        </h2>
        <p className="chapter-sub-text font-body">
          Open to mobile engineering (React Native / Android Java), full-stack roles, and collaborative projects.
        </p>

        {copied && (
          <div className="toast-notification font-mono">
            ✓ Copied shawaizali788@gmail.com to clipboard
          </div>
        )}

        <div className="contact-editorial-grid">
          <div className="direct-info-box">
            <div className="info-block">
              <span className="info-label font-mono">DIRECT EMAIL</span>
              <div className="email-copy-row">
                <a href="mailto:shawaizali788@gmail.com" className="email-link font-heading">
                  shawaizali788@gmail.com
                </a>
                <button className="btn-editorial btn-editorial-secondary copy-btn font-mono" onClick={handleCopyEmail}>
                  {copied ? 'COPIED' : 'COPY'}
                </button>
              </div>
            </div>

            <div className="info-block">
              <span className="info-label font-mono">NETWORKS</span>
              <div className="network-links font-heading">
                <a href="https://github.com/Shawaiz788" target="_blank" rel="noreferrer">GitHub</a>
                <span className="divider">•</span>
                <a href="https://www.linkedin.com/in/shawaiz-ali-rehman-52227427b/" target="_blank" rel="noreferrer">LinkedIn</a>
              </div>
            </div>

            <div className="info-block">
              <a href="/resume.pdf" download className="btn-editorial btn-editorial-primary">
                Download PDF Resume
              </a>
            </div>
          </div>

          <form className="contact-editorial-form" onSubmit={handleSubmit}>
            <h3 className="font-heading form-title">Send Message</h3>

            {submitted && (
              <div className="success-banner font-mono">
                ✓ Message sent successfully. I will get back to you soon.
              </div>
            )}

            {errorMsg && (
              <div className="error-banner font-mono">
                ✕ {errorMsg}
              </div>
            )}

            <div className="form-field">
              <label htmlFor="name" className="font-mono">NAME</label>
              <input
                id="name"
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Shawaiz Ali"
              />
            </div>

            <div className="form-field">
              <label htmlFor="email" className="font-mono">EMAIL</label>
              <input
                id="email"
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder="you@example.com"
              />
            </div>

            <div className="form-field">
              <label htmlFor="message" className="font-mono">MESSAGE</label>
              <textarea
                id="message"
                rows="4"
                required
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                placeholder="Tell me about your project or opportunity..."
              />
            </div>

            <button type="submit" className="btn-editorial btn-editorial-primary submit-btn" disabled={loading}>
              {loading ? 'SENDING...' : 'SEND MESSAGE'}
            </button>
          </form>
        </div>
      </div>

      <style jsx>{`
        .contact-chapter {
          padding-top: var(--section-padding-y);
          padding-bottom: var(--section-padding-y);
          background: var(--bg-surface);
        }

        .chapter-tag {
          color: var(--accent-gold);
          font-size: var(--font-size-caption);
          letter-spacing: 0.16em;
          margin-bottom: var(--space-2);
        }

        .chapter-headline {
          font-size: var(--font-size-title-1);
          line-height: var(--line-height-heading);
          margin-bottom: var(--space-4);
        }

        .chapter-sub-text {
          color: var(--text-muted);
          font-size: var(--font-size-body);
          max-width: var(--max-width-narrow);
          margin-bottom: var(--space-10);
        }

        .toast-notification {
          position: fixed;
          bottom: 2rem;
          right: 2rem;
          background: var(--accent-gold);
          color: #080a0f;
          padding: var(--space-3) var(--space-5);
          border-radius: 99px;
          font-size: 0.8rem;
          font-weight: bold;
          z-index: var(--z-modal);
        }

        .contact-editorial-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: var(--space-8);
        }

        .direct-info-box {
          display: flex;
          flex-direction: column;
          gap: var(--space-6);
        }

        .info-label {
          font-size: 0.72rem;
          color: var(--accent-gold);
          letter-spacing: 0.12em;
        }

        .email-copy-row {
          display: flex;
          align-items: center;
          gap: var(--space-3);
          margin-top: var(--space-1);
          flex-wrap: wrap;
        }

        .email-link {
          font-size: 1.25rem;
          color: var(--text-main);
          text-decoration: none;
        }

        .copy-btn {
          padding: var(--space-1) var(--space-3);
          font-size: 0.72rem;
        }

        .network-links {
          display: flex;
          gap: var(--space-3);
          margin-top: var(--space-1);
          font-size: 1.1rem;
        }

        .network-links a {
          color: var(--text-main);
          text-decoration: none;
        }

        .divider {
          color: var(--text-dim);
        }

        .contact-editorial-form {
          background: var(--bg-dark);
          padding: var(--space-6);
          border-radius: 16px;
          border: 1px solid var(--border-subtle);
          display: flex;
          flex-direction: column;
          gap: var(--space-4);
        }

        .form-title {
          font-size: 1.25rem;
          margin-bottom: var(--space-2);
        }

        .success-banner {
          background: rgba(16, 185, 129, 0.1);
          border: 1px solid rgba(16, 185, 129, 0.3);
          color: #10b981;
          padding: 0.75rem 1rem;
          border-radius: 8px;
          font-size: 0.78rem;
          letter-spacing: 0.05em;
        }

        .error-banner {
          background: rgba(239, 68, 68, 0.12);
          border: 1px solid rgba(239, 68, 68, 0.4);
          color: #f87171;
          padding: 0.75rem 1rem;
          border-radius: 8px;
          font-size: 0.78rem;
          letter-spacing: 0.05em;
          line-height: 1.5;
        }

        .form-field {
          display: flex;
          flex-direction: column;
          gap: var(--space-1);
        }

        .form-field label {
          font-size: 0.72rem;
          color: var(--text-dim);
          letter-spacing: 0.12em;
        }

        .form-field input,
        .form-field textarea {
          background: var(--bg-surface);
          border: 1px solid var(--border-medium);
          border-radius: 8px;
          padding: var(--space-3);
          color: var(--text-main);
          font-family: var(--font-body);
          font-size: var(--font-size-body-sm);
          outline: none;
          transition: border-color 0.2s ease;
        }

        .form-field input:focus,
        .form-field textarea:focus {
          border-color: var(--accent-gold);
        }

        .submit-btn {
          width: 100%;
          justify-content: center;
          margin-top: var(--space-2);
        }

        @media (max-width: 480px) {
          /* Stack grid single column */
          .contact-editorial-grid {
            grid-template-columns: 1fr;
            gap: 2rem;
          }

          /* Headline */
          .chapter-headline {
            font-size: clamp(1.8rem, 9vw, 2.8rem);
          }

          .chapter-sub-text {
            font-size: 0.9rem;
          }

          /* Email row — stack vertically */
          .email-copy-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.75rem;
          }

          .email-link {
            font-size: 1rem;
            word-break: break-all;
          }

          /* Copy button — full width pill */
          .copy-btn {
            width: 100%;
            min-height: 44px;
            justify-content: center;
            text-align: center;
          }

          /* Network links — larger spacing */
          .network-links {
            gap: 1rem;
            font-size: 1rem;
          }

          /* CRITICAL: Prevents iOS zoom on input focus */
          .form-field input,
          .form-field textarea {
            font-size: 16px;
          }

          /* Submit button — max tap target */
          .submit-btn {
            min-height: 52px;
            font-size: 0.85rem;
          }

          /* Toast — safe position for mobile */
          .toast-notification {
            bottom: 1.5rem;
            right: 1rem;
            left: 1rem;
            right: 1rem;
            text-align: center;
          }
        }
      `}</style>
    </section>
  );
};

export default ContactChapter;
